<script setup>
import { Actions, EventManager } from "@events";
import VideoCallButton from "../Common/VideoCallButton.vue";

import { useVideoCallState } from "@/stores/videoCallState";
import { computed } from "vue";

const props = defineProps({
  rtcId: {
    type: String,
    required: true,
  },
});

const actionEmitter = EventManager.getActionEmitter(props.rtcId);
const state = useVideoCallState(props.rtcId);

function toggleMute() {
  actionEmitter.emit(
    state.audioMuted ? Actions.UnmuteAudio : Actions.MuteAudio
  );
}

const iconClass = computed(() => {
  if (state.audioMuted) {
    return "mdi-microphone-off";
  }
  return "mdi-microphone";
});
</script>
<template>
  <VideoCallButton
    :active="state.audioMuted"
    :icon="iconClass"
    @click="toggleMute"
    :disabled="state.disableVideoControls"
  ></VideoCallButton>
</template>
